export const PARTNER_FILE_CREATED =
  "Charisma.Leasing.PublishedLanguage.Events.PartnerFileCreated";
export const PARTNER_FILE_NEXT_STATES_LIST_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.PartnerFileNextStatesComputed";
export const PARTNER_FILE_NEXT_STATES_LIST_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.PartnerFileNextStatesInvalidated";
export const PARTNER_FILE_STATE_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.PartnerFileStateUpdated";
